import { SliderCartesImageNom } from '@components/slider-cartes-image-nom/models';
import { Block } from '@shared/models';

export const sliderCartesImageNomMock: Block<SliderCartesImageNom> = {
  type: 'slider-cartes-image-nom',
  data: {
    title: {
      text: `La team SoCoo'c Annecy : [[100% à votre écoute]]`,
      as: 'span',
    },
  },
};
